/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespTradeSourcingBanner_user$ref = any;
type SbSharedMeasurementUnitProvider_user$ref = any;
type TradeRewardsMessagingWrapper_user$ref = any;
export type SbRespSearchResultContainer_user$ref = any;
export type SbRespSearchResultContainer_user = {
    readonly serviceId: string | null;
    readonly isVerifiedTrade: boolean | null;
    readonly tradeFirm?: {
        readonly serviceId: string | null;
    } | null;
    readonly " $fragmentRefs": SbSharedMeasurementUnitProvider_user$ref & TradeRewardsMessagingWrapper_user$ref & SbRespTradeSourcingBanner_user$ref;
    readonly " $refType": SbRespSearchResultContainer_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SbRespSearchResultContainer_user",
        "type": "User",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "isTrade",
                "type": "Boolean"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isVerifiedTrade",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isTrade",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "tradeFirm",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "SbSharedMeasurementUnitProvider_user",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "TradeRewardsMessagingWrapper_user",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SbRespTradeSourcingBanner_user",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '5191fc1dbecfc8552309692c679bce36';
export default node;
